import {serializeDraft, deserializeDraft} from "../offering-create-draft";

const SNAPSHOT_PREFIX = "coachli:oauth-form-snapshot:";
const SNAPSHOT_TTL_MS = 30 * 60 * 1000;

type SnapshotEnvelope = {
  ts: number;
  serialized: string;
};

export function writeFormSnapshot(pathKey: string, values: unknown): void {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  const envelope: SnapshotEnvelope = {ts: Date.now(), serialized: serializeDraft(values)};
  sessionStorage.setItem(SNAPSHOT_PREFIX + pathKey, JSON.stringify(envelope));
}

export function consumeFormSnapshot<T>(pathKey: string): T | null {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return null;
  }
  const key = SNAPSHOT_PREFIX + pathKey;
  const raw = sessionStorage.getItem(key);
  sessionStorage.removeItem(key);
  if (!raw) {
    return null;
  }
  try {
    const envelope = JSON.parse(raw) as SnapshotEnvelope;
    if (Date.now() - envelope.ts > SNAPSHOT_TTL_MS) {
      return null;
    }
    return deserializeDraft<T | null>(envelope.serialized, null);
  } catch {
    return null;
  }
}
